import { combineReducers } from 'redux';
import report from './report';
import nearby from './nearby';
import buoys from './buoys';
import idealConditions from './idealConditions';

export default combineReducers({
  report,
  nearby,
  buoys,
  idealConditions,
});



// WEBPACK FOOTER //
// ./src/reducers/spot/index.js